module.exports = __webpack_public_path__ + "img/logo.873f553c.webp";